import { Form } from "react-bootstrap";
import { getContactName } from "./utils";
import { ContactFormData, ContactHeaderProps, ContactTypeCode } from "./types";

export const ContactHeader = ({
    hideStored,
    onCopyContact,
    formData,
    customerContacts = [],
    onUseCustomerContact,
    requirements,
    contactType,
    idPrefix,
}: ContactHeaderProps) => {
    const isPremise = contactType === ContactTypeCode.Premise;
    const description = isPremise ? requirements?.premiseDescription : requirements?.primaryDescription;
    const title =
        description ||
        (isPremise ? "Where is the work being completed?" : "Who is the person we should contact regarding this application?");

    return (
        <div className="m-3">
            <h6 className="fs-6 fw-bold mb-3">{title}</h6>
            {contactType === ContactTypeCode.Primary && (
                <Form.Check
                    className="mb-3"
                    type="checkbox"
                    id={`${idPrefix}-same-as-home-business`}
                    label="Same as home/business information"
                    checked={Boolean((formData as ContactFormData)?.copyContact)}
                    onChange={onCopyContact}
                />
            )}
            <div className="d-flex align-items-center justify-content-between">
                {!hideStored && customerContacts.length > 0 && (
                    <Form.Group className="w-100" style={{ maxWidth: "320px" }} controlId={`${idPrefix}-storedContact`}>
                        <Form.Label>Choose from existing contact</Form.Label>
                        <Form.Select
                            value={formData?.storedContactNumber ?? ""}
                            onChange={(e) => {
                                onUseCustomerContact?.(customerContacts?.find((c) => c.contactNumber === e.target.value));
                            }}
                        >
                            <option disabled value={""}>
                                Select a contact...
                            </option>
                            {customerContacts.map((c) => (
                                <option key={c.contactNumber} value={c.contactNumber}>
                                    {getContactName(c)}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                )}
            </div>
        </div>
    );
};
